<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{appName}}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="content">
    <ion-row>
      <ion-col></ion-col>
      <ion-col size="8" size-xl="4">
        <p v-if="!esMovil">&nbsp;</p>
        <p v-if="!esMovil">&nbsp;</p>
        <p v-if="!esMovil">&nbsp;</p>
        <p v-if="!esMovil">&nbsp;</p>
        <p v-if="!esMovil">&nbsp;</p>
        <img src="/brand/logo.png" />
      </ion-col>
      <ion-col></ion-col>
    </ion-row>
    <!--ion-row>
      <ion-col></ion-col>
      <ion-col>
        <ion-button href="#/hola" expand="block">Hola</ion-button>
      </ion-col>
      <ion-col>
        <ion-button @click="toastTest" expand="block" color="tertiary">
          <i class="icon ion-ios-checkmark-circle"></i>&nbsp;
          toast
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button @click="alertTest" expand="block"> <i class="icon ion-ios-information-circle-outline"></i>&nbsp;
          alert</ion-button>
      </ion-col>
      <ion-col></ion-col>
    </ion-row-->
  </ion-content>
</ion-app>
</template>

<script>
import Api from '@/components/Api/Api'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      appName: Api.appName,
      yo: Api.fetchLocal('cmms.yo') || {},
      esMovil: Api.esMovil()
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    toastTest() {
      toast("Hola")
    },
    alertTest() {
      alert("Hola")
    }
  },
  async mounted() {
    await Api.wait(500)
    if (this.$route.path == '/')
      this.openEnd()
  }
}
</script>
